'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _shallowEqual = require('fbjs/lib/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _getTheme = require('./getTheme');

var _getTheme2 = _interopRequireDefault(_getTheme);

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _withSpacing = require('./withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = (0, _glamorous2.default)('div', {
  shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps, context, nextContext) {
    return props.fluid !== nextProps.fluid || !(0, _shallowEqual2.default)(context.theme, nextContext.theme);
  }
})({
  width: '100%',
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
  boxSizing: 'border-box'
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);
  return (0, _breakpoints2.default)(gridTheme.outer_gutter, gridTheme, function (size) {
    return size && {
      paddingLeft: size,
      paddingRight: size
    };
  });
}, function (props) {
  if (props.fluid) return;
  var gridTheme = (0, _getTheme2.default)(props);
  var containerWidths = gridTheme.max_container_width;
  return (0, _breakpoints2.default)(containerWidths, gridTheme, function (size) {
    return size && {
      width: size,
      maxWidth: '100%'
    };
  });
});
exports.default = (0, _withSpacing2.default)(Container);